/**
 * PolicyListContainer
 * --
 */
import React from 'react';
import PolicyListPresenter from './PolicyListPresenter';

const PolicyListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <PolicyListPresenter />
    </>
  );
};

export default PolicyListContainer;
